export const TICKET_CHAT_SUPPORT = 'ticket_chat_support';
export const AUTO_MONTHLY_CLOSING = 'auto_monthly_closing';
export const ORDERS_IMPORT = 'orders_import';
export const FISCAL_SPLIT = 'fiscal_split';
export const INVOICE_MANAGEMENT = 'invoice_management';
